import { ProductCodes } from './payments';

export const SUBSCRIPTION_TITLE = {
    APP_FULL_ACCESS: 'subscription.heading.personalizedProgram',
    APP_FULL_ACCESS_UPGRADED: 'subscription.heading.premiumPersonalizedProgram',
    OTHER: 'subscription.heading.subscription',

    /** Upsells */
    [ProductCodes.MEAL_PLAN_WORKOUTS_PACK]: 'subscription.heading.mealPlanWorkoutsPack',
    [ProductCodes.MEAL_PLANNER]: 'subscription.heading.mealPlanner',
    [ProductCodes.WORKOUT_PACK]: 'subscription.heading.workoutPack',
    [ProductCodes.WORKOUT_BUNDLE_LIFETIME]: 'subscription.heading.workoutBundleLifetime',
    [ProductCodes.ABS_WORKOUT]: 'subscription.heading.absWorkout',
    [ProductCodes.MOBILITY_STRETCHING]: 'subscription.heading.mobilityStretching',
    [ProductCodes.DANCING_WORKOUT]: 'subscription.heading.dancingWorkout',
    [ProductCodes.FAT_BURNING_INTERVAL]: 'subscription.heading.fatBurningInterval',
    [ProductCodes.NUTRITION]: 'subscription.heading.nutrition',
};

export enum DISCOUNT_TYPES {
    base = 'base',
    extra = 'extra',
}
